import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'
import { useGuestsCart } from 'components/common/MarchPromo/utils/useGuestsCart'
import Box from 'components/shared/Box'
import Loader from 'components/shared/Loader'
import { AddedVoucherInfoTile } from 'components/shared/Promotions/components/MarchPromoInfo/components/AddedVoucherInfoTile/AddedVoucherInfoTile'
import { CancelButton } from 'components/shared/Promotions/components/MarchPromoInfo/components/VoucherForm/styles'
import Text from 'components/shared/Text'
import { MARCH_PROMO_STANDARD_VOUCHER_PRICE } from 'constants/prices'
import { useContext, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { ActionButton } from './styles'

export const AddedVouchers = ({
    onEdit,
    onDeleteSuccess,
}: {
    onEdit: () => void
    onDeleteSuccess: () => void
}) => {
    const { deleteItemsFromCart, isDeleteLoading, isDeleteSuccess } =
        useGuestsCart()

    const { marchVouchersData, voucherPrice } = useContext(GuestsDataContext)

    useEffect(() => {
        if (!isDeleteSuccess) return
        onDeleteSuccess()
    }, [isDeleteSuccess])

    return (
        <Box
            direction="column"
            gap={16}
            px={[24, 80]}
            pb={[24, 40]}
            pt={[0, 20]}
            isFullWidth
        >
            {marchVouchersData.length !== 0 ? (
                <>
                    <Box
                        direction="row"
                        justify="space-between"
                        gap={12}
                        isFullWidth
                    >
                        <Text variant="heading3" color="grayscale_900">
                            <FormattedMessage
                                id="promo.march.added_vouchers"
                                defaultMessage="Dodane vouchery promocyjne"
                            />
                        </Text>
                        <Box direction="row" gap={[16, 24]}>
                            <ActionButton
                                disabled={isDeleteLoading}
                                onClick={() => onEdit()}
                            >
                                <FormattedMessage
                                    id="global.btn.edit"
                                    defaultMessage="Edytuj"
                                />
                            </ActionButton>
                            {isDeleteLoading ? (
                                <Loader />
                            ) : (
                                <CancelButton
                                    onClick={() => deleteItemsFromCart()}
                                >
                                    <FormattedMessage
                                        id="global.btn.remove"
                                        defaultMessage="Usuń"
                                    />
                                </CancelButton>
                            )}
                        </Box>
                    </Box>
                    <Text variant="bodySmall" color="grayscale_800">
                        {voucherPrice === MARCH_PROMO_STANDARD_VOUCHER_PRICE ? (
                            <FormattedMessage
                                id="promo.march.expiration_time_april"
                                defaultMessage="Ważność voucherów: do 30 kwietnia 2025"
                            />
                        ) : (
                            <FormattedMessage
                                id="promo.march.expiration_time_may"
                                defaultMessage="Ważność voucherów: do 31 maja 2025"
                            />
                        )}
                    </Text>
                    <Box direction="column" gap={16} isFullWidth>
                        {marchVouchersData.map((voucher, index) => (
                            <AddedVoucherInfoTile
                                key={index + 1}
                                voucher={voucher}
                            />
                        ))}
                    </Box>
                </>
            ) : (
                <Box align="center" isFullWidth>
                    <Loader />
                </Box>
            )}
        </Box>
    )
}
